// Kick message text carries emotes inline as [emote:ID:NAME]. This turns it into a flat list of
// pieces that the chat feed, reply previews and the message editor all render from.
//   { type: 'text', text }  { type: 'emote', id, name, url }  { type: 'link', url }
// Text pieces can be empty (e.g. between two adjacent emotes); the message renderer relies on
// them for spacing, so they are kept.

const EMOTE_SPLIT = /(\[emote:\d+:[^\]]+\])/g;
const EMOTE = /^\[emote:(\d+):([^\]]+)\]$/;
const LINK_SPLIT = /(https?:\/\/[^\s]+)/g;
const LINK = /^https?:\/\/[^\s]+$/;

export const emoteUrl = (id) => `https://files.kick.com/emotes/${id}/fullsize`;

// `links: false` leaves URLs inside text pieces (reply previews and the editor show them as plain text)
export function parseKickContent(content, { links = true } = {}) {
  if (!content) return [];
  const pieces = [];
  content.split(EMOTE_SPLIT).forEach((part) => {
    const emote = part.match(EMOTE);
    if (emote) {
      pieces.push({ type: 'emote', id: emote[1], name: emote[2], url: emoteUrl(emote[1]) });
    } else if (!links) {
      pieces.push({ type: 'text', text: part });
    } else {
      part.split(LINK_SPLIT).forEach((seg) => {
        pieces.push(LINK.test(seg) ? { type: 'link', url: seg } : { type: 'text', text: seg });
      });
    }
  });
  return pieces;
}

// Cut text/emote pieces to maxLength characters; an emote counts as the length of its name.
// An emote that would cross the limit is dropped; text is cut mid-way.
export function truncateKickContent(pieces, maxLength) {
  const kept = [];
  let length = 0;
  for (const piece of pieces) {
    if (piece.type === 'emote') {
      length += piece.name.length;
      if (length > maxLength) return { pieces: kept, truncated: true };
      kept.push(piece);
    } else {
      const text = piece.type === 'link' ? piece.url : piece.text;
      if (length + text.length > maxLength) {
        kept.push({ type: 'text', text: text.substring(0, maxLength - length) });
        return { pieces: kept, truncated: true };
      }
      length += text.length;
      kept.push(piece);
    }
  }
  return { pieces: kept, truncated: false };
}
